module.exports = function(h, row) {
    var v = row.variants;

    if (!row.use_variant) {
        return <i class="text-muted">N/A</i>;
    }

    if (v.length == 1) {
        return v[0].name;
    }

    if (v.length == 2) {
        return `${v[0].name} and ${v[1].name}`;
    }

    if (v.length == 3) {
        return `${v[0].name}, ${v[1].name} and ${v[2].name}`;
    }

    if (v.length > 3) {
        const total = v.length - 2;
        return `${v[0].name}, ${v[1].name} and +${total} variants`;
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/components/product/columns/variants.jsx